import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import type { Client } from "../types";

export interface MergeClientsModalProps {
  open: boolean;
  clients: Client[]; // the selected clients (>= 2)
  onConfirm: (targetId: string) => void;
  onCancel: () => void;
}

export const MergeClientsModal = ({
  open,
  clients,
  onConfirm,
  onCancel,
}: MergeClientsModalProps): JSX.Element => {
  const [targetId, setTargetId] = useState<string>("");

  // Reset the chosen target whenever the modal opens or the selection changes.
  useEffect(() => {
    if (open) setTargetId("");
  }, [open, clients]);

  return (
    <Modal show={open} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Merge clients</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Choose the client to keep. The other {clients.length - 1} client(s)
          will be merged into it and removed.
        </p>
        {clients.map((c) => (
          <Form.Check
            key={c.id}
            type="radio"
            name="merge-target"
            id={`merge-target-${c.id}`}
            label={c.name}
            checked={targetId === c.id}
            onChange={() => setTargetId(c.id)}
          />
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btnSeawhite" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          className="squareGreenButton"
          disabled={!targetId}
          onClick={() => onConfirm(targetId)}
        >
          Merge
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MergeClientsModal;
